import {
  FloatingFormItem,
  InputDecimal,
  InputText,
} from '@/components/_common';
import { PurchaseItemsFormValues } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Col, Form, FormInstance, Row } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<PurchaseItemsFormValues>;
}

const IpiForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { purchase } = useReleasePurchaseFormContext();

  return (
    <Form form={form}>
      <Row gutter={[12, 12]}>
        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'cstIpi']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ipi.taxRegime.cstIpi',
            })}
          >
            <InputText
              onlyNumber
              maxLength={4}
              disabled={purchase?.boschMigration}
            />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaIpi']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ipi.taxRegime.quotaIpi',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'baseIpi']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ipi.taxRegime.baseIpi',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueIpi']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.ipi.taxRegime.valueIpi',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default IpiForm;
